import bluebird from 'bluebird'
import './bootstrap'

window.Promise = bluebird
window.$ = window.jQuery = require('jquery')

window.Handlebars = require('handlebars')

require('jquery-migrate')

// ponytail: jQuery 3 dropped .selector, $.browser and event.mouseHooks, which jquery.form, jqprint and
// DevExtreme 16.1 (Scripts/dx.*.js) still use (jquery-migrate 1.x used to restore them). Delete once
// those vendor scripts are replaced. .live() is kept only as a warning safety net: our code uses
// $(document).on(evt, sel, fn) now.
const jQueryInit = $.fn.init
$.fn.init = function (selector, context) {
  const ret = jQueryInit.apply(this, arguments)
  if (typeof selector === 'string') {
    ret.selector = selector
    ret.context = context || document
  }
  return ret
}
$.fn.init.prototype = $.fn
$.fn.live = function (types, data, fn) {
  console.warn(`JQMIGRATE: jQuery.fn.live() is removed; use $(document).on('${types}', '${this.selector}', fn)`)
  $(this.context || document).on(types, this.selector, data, fn)
  return this
}
$.browser = $.browser || {}
$.event.mouseHooks = $.event.mouseHooks || {
  props: 'button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement'.split(' ')
}
// MELPES-5338 - jQuery 2 put a <tr> appended to a <table> into its <tbody>; jQuery 3 doesn't. DevExtreme 16.1 grids
// only look for rows under table > tbody, so every row click resolved to index -1 and rows couldn't be selected
// (e.g. Create Tracking Event's Update button stayed disabled). Delete with the other DevExtreme shims above.
const jQueryAppend = $.fn.append
$.fn.append = function () {
  jQueryAppend.apply(this, arguments)
  return this.each(function () {
    const $rows = this.nodeName === 'TABLE' ? $(this).children('tr') : $()
    if ($rows.length) jQueryAppend.call($(this.tBodies[0] || this.appendChild(document.createElement('tbody'))), $rows)
  })
}

// the package's main is only the widget factory; dist/ is the full build (datepicker, autocomplete, dialog...)
require('jquery-ui/dist/jquery-ui')

require('metismenu')
require('moment')
window.moment = require('moment')
require('sweetalert')
require('bootstrap-sass/assets/javascripts/bootstrap.js')
// Bootstrap 3's modal data-api runs $(document).find('#') for <a href="#" data-toggle="modal">. jQuery 3 throws on '#'
// (jQuery 2 returned nothing), aborting the page's own document click handlers (e.g. View Manifest). Give these links
// a target that matches nothing, as jQuery 2 effectively did. Capture phase so it runs before Bootstrap's handler.
document.addEventListener('click', function (e) {
  var link = e.target.closest && e.target.closest('a[href="#"][data-toggle="modal"]:not([data-target])')
  if (link) link.setAttribute('data-target', ':not(*)')
}, true)

require('./vendor/daterangepicker')
require('./vendor/jquery.form.min')
require('./vendor/jquery.form-validator')

require('datatables.net-bs')
require('datatables.net-buttons-bs')
require('datatables.net-buttons/js/buttons.html5.js')
require('datatables.net-select-bs')

require('./vendor/validation.js')
require('./vendor/jquery.dataTables.rowGrouping')
require('./vendor/sorting.currency.js')
require('jquery-validation')
require('./vendor/jquery.unobtrusive-ajax.js')
require('./vendor/jquery.timepicker.js')
require('./vendor/jquery.cookie.js')
require('./vendor/jquery.number.js')
require('./vendor/jquery.plugin.clipboard.js')
require('./vendor/jquery.jqprint-0.3.js')
require('select2') // webpack takes the UMD's AMD branch, which registers $.fn.select2 on load

require('./common/polyfills')
